import { isAdminViewer, UserState } from "../../../store/User";
import { ApplicationState } from "../../../store";
import { connect } from "react-redux";
import { PPMFeatures, Subscription } from "../../../store/Tenant";
import { PublicApiType } from "./PATCreationPanel";
import { notUndefined } from "../../utils/common";
import { Section } from "../../../entities/Metadata";
import SectionableSettingsPage from "../SectionableSettingsPage";
import ApiInfoTooltip from "../../common/sectionsControl/uiControls/publicApiControl/ApiInfoTooltip";

export const AutomationSectionKeys = {
    apiSection: "apiSection",
    patSection: "patSection",
    zapierSection: "zapierSection"
} as const;

type AutomationSectionKeys = typeof AutomationSectionKeys[keyof typeof AutomationSectionKeys];

const automationSectionMap: Record<AutomationSectionKeys,
    { name: string, iconName: string, tooltip: JSX.Element | undefined, controlName: string, navigationLabel?: string }> = {
    [AutomationSectionKeys.apiSection]: {
        name: 'Public API',
        iconName: 'AzureAPIManagement',
        tooltip: <ApiInfoTooltip />,
        controlName: 'PublicApiControl',
    },
    [AutomationSectionKeys.patSection]: {
        name: "Personal access tokens",
        navigationLabel: "PAT",
        iconName: "AzureKeyVault",
        tooltip: undefined,
        controlName: "PATListControl"
    },
    [AutomationSectionKeys.zapierSection]: {
        name: "Zapier",
        iconName: "PPMXZapier",
        tooltip: undefined,
        controlName: "ZapierControl"
    }
}

const buildSectionSettings = (key: AutomationSectionKeys, isSelected = true, isOpen = true, isAccessible = true, uiControlsSections = []): Section => ({
    id: key,
    name: automationSectionMap[key].name,
    navigationLabel: automationSectionMap[key].navigationLabel,
    settings: {
        iconName: automationSectionMap[key].iconName,
        tooltip: automationSectionMap[key].tooltip,
    },
    isSelected: isSelected,
    isOpen: isOpen,
    isAccessible: isAccessible,
    uiControls: [{
        id: key,
        type: automationSectionMap[key].controlName,
        settings: uiControlsSections
    }]
});

type Props = { user: UserState, subscription: Subscription };

const Automation = (props: Props) => {
    const availableApiTypes = getApiTypes(props.user, props.subscription);
    const sections: Section[] = [
        buildSectionSettings(AutomationSectionKeys.apiSection, availableApiTypes.includes(PublicApiType.general)),
        buildSectionSettings(AutomationSectionKeys.patSection, !!availableApiTypes.length),
        buildSectionSettings(AutomationSectionKeys.zapierSection, availableApiTypes.includes(PublicApiType.general))
    ];

    return <SectionableSettingsPage 
        title="Automation" 
        sections={sections}
        settingsKey="automationSettings" />;
}

export const getApiTypes = (user: UserState, subscription: Subscription): PublicApiType[] => [
    Subscription.contains(subscription, PPMFeatures.API) && !isAdminViewer(user)
        ? PublicApiType.general
        : undefined,
    Subscription.contains(subscription, PPMFeatures.IntegrationAPI)
        ? PublicApiType.integration
        : undefined]
    .filter(notUndefined);
    
function mapStateToProps(state: ApplicationState): Props {
    return {
        user: state.user,
        subscription: state.tenant.subscription
    };
}

export default connect(mapStateToProps)(Automation);